<template>
	<a :href="url" class="whatsapp-link" :class="{'floating' : floating, 'inline' : !floating}" target="_blank" v-if="show">
		<i class="lnr icon-whatsapp"></i>
		<span v-if="!floating">WhatsApp</span>
	</a>
</template>

<script>
import { contact_information } from "~app_root/public/tv/app.config";

export default {

	name: "WhatsAppLink",
	data(){
		return {
			show : false
		}
	},
	props : {
		floating : {
			type : Boolean,
			default : true
		}
	},
	computed : {

		url(){
			return `https://wa.me/${contact_information.whatsapp_phone_number}`
		}

	},
	mounted(){

		if(typeof document !== 'undefined' && ("ontouchstart" in document.documentElement)){
      		this.show = true;
    	}

	}

}
</script>